// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { MapPin } from 'lucide-react';
// import Header from '../components/Header';
// import HeroBanner from '../components/HeroBanner';
// import ShopCard from '../components/ShopCard';
// import LoadingShopCard from '../components/LoadingShopCard';
// import { toast } from 'sonner';

// // const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
// // Change line 13
// const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000';
// const API = `${BACKEND_URL}/api`;

// const HomePage = () => {
//   const [shops, setShops] = useState([]);
//   const [featuredShops, setFeaturedShops] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [location, setLocation] = useState({ lat: -7.0393, lon: 112.7618 });
//   const [searchQuery, setSearchQuery] = useState('');
//   const [currentPage, setCurrentPage] = useState(5); // Start from page 5 since we preload 1-5
//   const [hasMore, setHasMore] = useState(true);
//   const [initialLoading, setInitialLoading] = useState(true);

//   // Fetch featured shops from backend
//   const fetchFeaturedShops = async () => {
//     try {
//       const response = await axios.get(`${API}/featured-shops`);
//       setFeaturedShops(response.data);
//     } catch (error) {
//       console.error('Error fetching featured shops:', error);
//     }
//   };

//   // Fetch shops from external API via backend proxy
//   const fetchShops = async (page = 1, isInitial = false) => {
//     try {
//       setLoading(true);
//       const response = await axios.get(
//         `${API}/shops/${page}/${location.lon}/${location.lat}`
//       );
      
//       if (response.data && response.data.data) {
//         const newShops = response.data.data;
//         if (isInitial || page === 1) {
//           setShops(newShops);
//         } else {
//           setShops(prev => [...prev, ...newShops]);
//         }
//         setHasMore(newShops.length > 0);
//       }
//     } catch (error) {
//       console.error('Error fetching shops:', error);
//       if (!isInitial) {
//         toast.error('Gagal memuat data warung');
//       }
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Fetch initial multiple pages to ensure all featured shops are loaded
//   const fetchInitialShops = async () => {
//     try {
//       setInitialLoading(true);
//       // Fetch first 5 pages to ensure all featured shops are available
//       const pages = [1, 2, 3, 4, 5];
//       const promises = pages.map(page => 
//         axios.get(`${API}/shops/${page}/${location.lon}/${location.lat}`)
//       );
      
//       const results = await Promise.all(promises);
//       const allShops = results.flatMap(res => res.data?.data || []);
//       setShops(allShops);
//       setHasMore(true);
//     } catch (error) {
//       console.error('Error fetching initial shops:', error);
//       toast.error('Gagal memuat data warung');
//     } finally {
//       setInitialLoading(false);
//       setLoading(false);
//     }
//   };

//   // Get user location
//   const getUserLocation = () => {
//     if (navigator.geolocation) {
//       navigator.geolocation.getCurrentPosition(
//         (position) => {
//           setLocation({
//             lat: position.coords.latitude,
//             lon: position.coords.longitude
//           });
//           toast.success('Lokasi berhasil didapatkan');
//         },
//         (error) => {
//           console.error('Error getting location:', error);
//           toast.info('Menggunakan lokasi default: Bangkalan');
//         }
//       );
//     }
//   };

//   useEffect(() => {
//     getUserLocation();
//     fetchFeaturedShops();
//   }, []);

//   useEffect(() => {
//     fetchInitialShops();
//   }, [location]);

//   // Filter shops that are not in featured list
//   const nonFeaturedShops = shops.filter(
//     shop => !featuredShops.some(featured => featured.alias === shop.alias)
//   );

//   // Filter by search query
//   const filteredShops = searchQuery
//     ? nonFeaturedShops.filter(shop =>
//         shop.store_name.toLowerCase().includes(searchQuery.toLowerCase()) ||
//         shop.address.toLowerCase().includes(searchQuery.toLowerCase())
//       )
//     : nonFeaturedShops;

//   const loadMore = () => {
//     const nextPage = currentPage + 1;
//     setCurrentPage(nextPage);
//     fetchShops(nextPage, false);
//   };

//   return (
//     <div className="min-h-screen bg-background">
//       <Header searchQuery={searchQuery} setSearchQuery={setSearchQuery} />
      
//       <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 space-y-8">
//         <HeroBanner />
        
//         {/* Featured Shops Section - UMKM Pilihan */}
//         {featuredShops.length > 0 && (
//           <section className="animate-fade-in">
//           <div className="bg-gradient-to-r from-orange-700 via-orange-600 to-amber-500 text-white rounded-lg px-6 py-4 mb-6 flex items-center justify-between shadow-md">
//           {/* <div className="bg-primary text-white rounded-lg px-6 py-4 mb-6 flex items-center justify-between"> */}
//   <h2 className="text-2xl font-bold">UMKM Pilihan</h2>
//   <span className="text-sm opacity-90">
//     {featuredShops.length} UMKM terpilih
//   </span>
// </div>
//             {/* <div className="flex items-center justify-between mb-6">
//               <div className="flex items-center gap-3">
//                 <h2 className="text-2xl font-bold text-white bg-primary px-6 py-2 rounded-lg">
//                   UMKM Pilihan
//                 </h2>
//                 <span className="text-sm text-muted-foreground">
//                   {featuredShops.length} UMKM terpilih
//                 </span>
//               </div>
//             </div> */}
//             <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
//               {featuredShops.map((shop, index) => {
//                 const shopData = shops.find(s => s.alias === shop.alias);
//                 if (!shopData) return null;
//                 return (
//                   <ShopCard 
//                     key={shop.alias} 
//                     shop={shopData} 
//                     featured={true}
//                     delay={index * 50}
//                   />
//                 );
//               })}
//             </div>
//           </section>
//         )}
        
//         {/* All Shops Section - Warung Terdekat */}
//         <section className="animate-fade-in">
//         <div className="bg-gradient-to-r from-blue-700 via-sky-600 to-cyan-400 text-white rounded-lg px-6 py-4 mb-6 flex items-center justify-between shadow-md">
//         {/* <div className="bg-primary text-white rounded-lg px-6 py-4 mb-6 flex items-center justify-between"> */}
//   <h2 className="text-2xl font-bold">Warung Terdekat</h2>
//   <div className="flex items-center gap-2 text-sm opacity-90">
//     <MapPin className="w-4 h-4" />
//     <span>{filteredShops.length} warung ditemukan</span>
//   </div>
// </div>
//           {/* <div className="flex items-center justify-between mb-6">
//             <div className="flex items-center gap-3">
//               <h2 className="text-2xl font-bold text-white bg-primary px-6 py-2 rounded-lg">
//                 Warung Terdekat
//               </h2>
//               <div className="flex items-center gap-2 text-sm text-muted-foreground">
//                 <MapPin className="w-4 h-4" />
//                 <span>{filteredShops.length} warung ditemukan</span>
//               </div>
//             </div>
//           </div> */}
          
//           {loading && currentPage === 5 && initialLoading ? (
//             <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
//               {[1, 2, 3, 4, 5, 6].map((i) => (
//                 <LoadingShopCard key={i} />
//               ))}
//             </div>
//           ) : filteredShops.length === 0 ? (
//             <div className="text-center py-16 bg-surface rounded-xl border border-border">
//               <div className="text-6xl mb-4">🔍</div>
//               <h3 className="text-xl font-semibold text-foreground mb-2">
//                 Tidak ada warung ditemukan
//               </h3>
//               <p className="text-muted-foreground">
//                 Coba ubah kata kunci pencarian Anda
//               </p>
//             </div>
//           ) : (
//             <>
//               <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
//                 {filteredShops.map((shop, index) => (
//                   <ShopCard 
//                     key={shop.alias} 
//                     shop={shop}
//                     delay={index * 30}
//                   />
//                 ))}
//               </div>
              
//               {hasMore && !searchQuery && (
//                 <div className="flex justify-center mt-8">
//                   <button
//                     onClick={loadMore}
//                     disabled={loading}
//                     className="px-8 py-3 bg-primary text-primary-foreground rounded-lg font-medium hover:bg-primary-hover transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
//                   >
//                     {loading ? 'Memuat...' : 'Muat Lebih Banyak'}
//                   </button>
//                 </div>
//               )}
//             </>
//           )}
//         </section>
//       </main>
      
//       {/* Footer */}
//       <footer className="bg-surface border-t border-border mt-16">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
//           <div className="text-center text-muted-foreground">
//             <p className="text-sm">© 2025 UMKMBangkalan.com - Platform UMKM & Warung Terdekat</p>
//             <p className="text-xs mt-2">Belanja kebutuhan harian dari warung sekitar Anda</p>
//           </div>
//         </div>
//       </footer>
//     </div>
//   );
// };

// export default HomePage;

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { MapPin } from 'lucide-react';
import Header from '../components/Header';
import HeroBanner from '../components/HeroBanner';
import ShopCard from '../components/ShopCard';
import LoadingShopCard from '../components/LoadingShopCard';
import { toast } from 'sonner';

// const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000';
const API = `${BACKEND_URL}/api`;

const HomePage = () => {
  const [shops, setShops] = useState([]);
  const [featuredShops, setFeaturedShops] = useState([]);
  const [loading, setLoading] = useState(true);
  const [location, setLocation] = useState({ lat: -7.0267892, lon: 112.7268943 });
  const [searchQuery, setSearchQuery] = useState('');
  const [currentPage, setCurrentPage] = useState(5); // Start from page 5 since we preload 1-5
  const [hasMore, setHasMore] = useState(true);
  const [initialLoading, setInitialLoading] = useState(true);

  // Fetch featured shops from backend
  const fetchFeaturedShops = async () => {
    try {
      const response = await axios.get(`${API}/featured-shops`);
      setFeaturedShops(response.data);
    } catch (error) {
      console.error('Error fetching featured shops:', error);
    }
  };

  // Fetch shops from external API via backend proxy
  const fetchShops = async (page = 1, isInitial = false) => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${API}/shops/${page}/${location.lon}/${location.lat}`
      );
      
      if (response.data && response.data.data) {
        const newShops = response.data.data;
        if (isInitial || page === 1) {
          setShops(newShops);
        } else {
          setShops(prev => [...prev, ...newShops]);
        }
        setHasMore(newShops.length > 0);
      }
    } catch (error) {
      console.error('Error fetching shops:', error);
      if (!isInitial) {
        toast.error('Gagal memuat data warung');
      }
    } finally {
      setLoading(false);
    }
  };

  // Fetch initial multiple pages to ensure all featured shops are loaded
  const fetchInitialShops = async () => {
    try {
      setInitialLoading(true);
      // Fetch first 5 pages to ensure all featured shops are available
      const pages = [1, 2, 3, 4, 5, 6, 7, 8];
      const promises = pages.map(page => 
        axios.get(`${API}/shops/${page}/${location.lon}/${location.lat}`)
      );
      
      const results = await Promise.all(promises);
      const allShops = results.flatMap(res => res.data?.data || []);
      setShops(allShops);
      setHasMore(true);
    } catch (error) {
      console.error('Error fetching initial shops:', error);
      toast.error('Gagal memuat data warung');
    } finally {
      setInitialLoading(false);
      setLoading(false);
    }
  };

  // Get user location
  const getUserLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setLocation({
            lat: position.coords.latitude,
            lon: position.coords.longitude
          });
          toast.success('Lokasi berhasil didapatkan');
        },
        (error) => {
          console.error('Error getting location:', error);
          toast.info('Menggunakan lokasi default: Bangkalan');
        }
      );
    }
  };

  useEffect(() => {
    getUserLocation();
    fetchFeaturedShops();
  }, []);

  useEffect(() => {
    fetchInitialShops();
  }, [location]);

  // Filter shops that are not in featured list
  const nonFeaturedShops = shops.filter(
    shop => !featuredShops.some(featured => featured.alias === shop.alias)
  );

  // Filter by search query
  const filteredShops = searchQuery
    ? nonFeaturedShops.filter(shop =>
        shop.store_name.toLowerCase().includes(searchQuery.toLowerCase()) ||
        shop.address.toLowerCase().includes(searchQuery.toLowerCase())
      )
    : nonFeaturedShops;

  const loadMore = () => {
    const nextPage = currentPage + 1;
    setCurrentPage(nextPage);
    fetchShops(nextPage, false);
  };

  return (
    <div className="min-h-screen bg-background">
      <Header searchQuery={searchQuery} setSearchQuery={setSearchQuery} />
      
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 space-y-8">
        <HeroBanner />
        
        {/* Featured Shops Section - UMKM Pilihan */}
        {featuredShops.length > 0 && (
          <section className="animate-fade-in">
          <div className="bg-gradient-to-r from-orange-700 via-orange-600 to-amber-500 text-white rounded-lg px-6 py-4 mb-6 flex items-center justify-between shadow-md">
          {/* <div className="bg-primary text-white rounded-lg px-6 py-4 mb-6 flex items-center justify-between"> */}
  <h2 className="text-2xl font-bold">UMKM Pilihan</h2>
  <span className="text-sm opacity-90">
    {featuredShops.length} UMKM terpilih
  </span>
</div>
            {/* <div className="flex items-center justify-between mb-6">
              <div className="flex items-center gap-3">
                <h2 className="text-lg sm:text-2xl font-bold text-white bg-primary px-4 sm:px-6 py-1.5 sm:py-2 rounded-lg">
                  UMKM Pilihan
                </h2>
                <span className="text-xs sm:text-sm text-muted-foreground">
                  {featuredShops.length} UMKM terpilih
                </span>
              </div>
            </div> */}
            {/* <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
              {featuredShops.map((shop, index) => {
                const shopData = shops.find(s => s.alias === shop.alias);
                // if (!shopData) return null;
                return (
                  <ShopCard 
                    key={shop.alias} 
                    shop={shopData} 
                    featured={true}
                    delay={index * 50}
                  />
                );
              })}
            </div> */}
            <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
  {featuredShops
    .map((shop) => {
      const shopData = shops.find(s => s.alias === shop.alias);
      return { ...shop, shopData };
    })
    .filter(item => item.shopData) // Remove shops without data
    .sort((a, b) => {
      // Sort: "open" first, "closed" last
      if (a.shopData.is_open === 'open' && b.shopData.is_open === 'closed') return -1;
      if (a.shopData.is_open === 'closed' && b.shopData.is_open === 'open') return 1;
      return 0; // Same status = keep original order
    })
    .map((item, index) => (
      <ShopCard 
        key={item.shopData.alias} 
        shop={item.shopData} 
        featured={true}
        delay={index * 50}
      />
    ))
  }
</div>
          </section>
        )}
        
        {/* All Shops Section - Warung Terdekat */}
        <section className="animate-fade-in">
        <div className="bg-gradient-to-r from-blue-700 via-sky-600 to-cyan-400 text-white rounded-lg px-6 py-4 mb-6 flex items-center justify-between shadow-md">
        {/* <div className="bg-primary text-white rounded-lg px-6 py-4 mb-6 flex items-center justify-between"> */}
  <h2 className="text-2xl font-bold">Warung Terdekat</h2>
  <div className="flex items-center gap-2 text-sm opacity-90">
    <MapPin className="w-4 h-4" />
    <span>{filteredShops.length} warung ditemukan</span>
  </div>
</div>
          {/* <div className="flex items-center justify-between mb-6">
            <div className="flex items-center gap-3">
              <h2 className="text-lg sm:text-2xl font-bold text-white bg-primary px-4 sm:px-6 py-1.5 sm:py-2 rounded-lg">
                Warung Terdekat
              </h2>
              <div className="flex items-center gap-2 text-xs sm:text-sm text-muted-foreground">
                <MapPin className="w-3 h-3 sm:w-4 sm:h-4" />
                <span className="hidden sm:inline">{filteredShops.length} warung ditemukan</span>
                <span className="sm:hidden">{filteredShops.length}</span>
              </div>
            </div>
          </div> */}
          
          {loading && currentPage === 5 && initialLoading ? (
            <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
              {[1, 2, 3, 4, 5, 6].map((i) => (
                <LoadingShopCard key={i} />
              ))}
            </div>
          ) : filteredShops.length === 0 ? (
            <div className="text-center py-16 bg-surface rounded-xl border border-border">
              <div className="text-6xl mb-4">🔍</div>
              <h3 className="text-xl font-semibold text-foreground mb-2">
                Tidak ada warung ditemukan
              </h3>
              <p className="text-muted-foreground">
                Coba ubah kata kunci pencarian Anda
              </p>
            </div>
          ) : (
            <>
              <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
                {filteredShops.map((shop, index) => (
                  <ShopCard 
                    key={shop.alias} 
                    shop={shop}
                    delay={index * 30}
                  />
                ))}
              </div>
              
              {hasMore && !searchQuery && (
                <div className="flex justify-center mt-8">
                  <button
                    onClick={loadMore}
                    disabled={loading}
                    className="px-8 py-3 bg-primary text-primary-foreground rounded-lg font-medium hover:bg-primary-hover transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    {loading ? 'Memuat...' : 'Muat Lebih Banyak'}
                  </button>
                </div>
              )}
            </>
          )}
        </section>
      </main>
      
      {/* Footer */}
      <footer className="bg-surface border-t border-border mt-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <div className="text-center text-muted-foreground">
            <p className="text-sm">© 2025 UMKMBangkalan.com - Platform UMKM & Warung Terdekat</p>
            <p className="text-xs mt-2">Belanja kebutuhan harian dari warung sekitar Anda</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default HomePage;
